import * as React from "react";
import {UIState} from "data/UIState";
import {action} from "mobx";
import {PageEnums} from "components/nav/PageEnums";
import {WellnessConceptsLogo} from "components/widgets/WellnessConceptsLogo";

import './HRTitleBar.pcss';

export const HRTitleBar = (props:{}) =>
  <div className={"hr-title-bar"}>
    <div className={"left"}>
      <div className={"dashboard-button"} role="button" aria-label={"Back to Dashboard"} onClick={action(() => {
        UIState.currentPage = PageEnums.dashboard;
      })}>
        <span className={"material-symbols-outlined"}>arrow_back_ios</span>
        <span className={"dashboard-button-text"}>Dashboard</span>
      </div>
      <WellnessConceptsLogo variant={'favicon gradient'} size={34}/>
      <div className={"text"}>
        <h1>Platform Admin</h1>
        <h2>{UIState.settings.COMPANY_NAME}</h2>
      </div>
    </div>
  </div>
;
